import { baseApi } from "./base.api";

export const productsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    fetchProducts: build.query({
      query: (params) => ({ url: "/products/fetch", method: "GET", params }),
      providesTags: ["Product"],
    }),
   
    fetchProductsAll: build.query({
      query: () => ({ url: "/products/fetch/all", method: "GET" }),
      providesTags: ["Product"],
    }),
    fetchTrashedProducts: build.query({
      query: (params) => ({ url: "/products/fetch/trashed", method: "GET", params }),
      providesTags: ["Product"],
    }),
    fetchCategoryByBrandId: build.query({
      query : (brand_id) => ({url:`/products/fetch_category_by_brand/${brand_id}`, method:"GET"}),
      providesTags: ["Categories"]
    }),
    fetchSubCategoryByCatId: build.query({
      query : (category_id) => ({url:`/products/sub_category_cascade/${category_id}`, method:"GET"}),
      providesTags: ["Sub Categories"]
    }),
    fetchProductById: build.query({
      query: (id) => ({ url: `/products/fetch/${id}`, method: "GET" }),
      providesTags: ["Product"],
    }),
    exportExcelTemplate: build.mutation({
      query: () => ({
          url: '/products/export/excel/template',
          method: 'GET',
          responseHandler: async (response) => await response.blob(),
          cache: 'no-cache',
      }),
  }),
    exportProductExcel: build.mutation({
      query: () => ({
          url: '/products/export/product',
          method: 'GET',
          responseHandler: async (response) => await response.blob(),
          cache: 'no-cache',
      }),
  }),
    createProduct: build.mutation({
      query: (body) => ({ url: "/products/create", method: "POST", body }),
      invalidatesTags: ["Product"],
    }),
    updateProduct: build.mutation({
      query: ({ id, body }) => ({ url: `/products/update/${id}`, method: "PUT", body }),
      invalidatesTags: ["Product"],
    }),
    changeProductStatus: build.mutation({
      query: (id) => ({ url: `/products/status/${id}`, method: "PUT" }),
      invalidatesTags: ["Product"],
    }),
    restoreProduct: build.mutation({
      query: (id) => ({ url: `/products/restore/${id}`, method: "PUT" }),
      invalidatesTags: ["Product"],
    }),
    bulkRestoreProducts: build.mutation({
      query: (body) => ({ url: "/products/bulk-restore", method: "POST", body }),
      invalidatesTags: ["Product"],
    }),
    deleteProduct: build.mutation({
      query: (id) => ({ url: `/products/delete/${id}`, method: "DELETE" }),
      invalidatesTags: ["Product"],
    }),
    bulkDeleteProducts: build.mutation({
      query: (body) => ({ url: "/products/bulk-delete", method: "POST", body }),
      invalidatesTags: ["Product"],
    }),
    destroyProduct: build.mutation({
      query: (id) => ({ url: `/products/destroy/${id}`, method: "DELETE" }),
      invalidatesTags: ["Product"],
    }),
    bulkDestroyProducts: build.mutation({
      query: (body) => ({ url: "/products/bulk-destroy", method: "POST", body }),
      invalidatesTags: ["Product"],
    }),
  }),
});

export const {
  useFetchProductsQuery,
  useFetchProductsAllQuery,
  useFetchTrashedProductsQuery,
  useFetchProductByIdQuery,
  useCreateProductMutation,
  useUpdateProductMutation,
  useChangeProductStatusMutation,
  useRestoreProductMutation,
  useBulkRestoreProductsMutation,
  useDeleteProductMutation,
  useBulkDeleteProductsMutation,
  useDestroyProductMutation,
  useFetchSubCategoryByCatIdQuery,
  useFetchCategoryByBrandIdQuery,
  useBulkDestroyProductsMutation,
  useExportExcelTemplateMutation,
  useExportProductExcelMutation
} = productsApi;
